
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";
import TopLoader from "../components/Loader/TopLoader";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { getstudentinfo } from "../api/Users";
import { TextField, TablePagination } from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import pdfLogo from "../images/login1.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const DownloadDailyHomework = ({ userData }) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const rowData = location.state;
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [dailyHomework, setDailyHomework] = useState({
    from_date: "",
    to_date: "",
  })
  const [error, setErrors] = useState({});
  useEffect(() => {
    if (rowData) {
      setDailyHomework((prevDailyHomework) => ({
        ...prevDailyHomework,
        ...rowData,
      }));
    }
    const getStudentDetails = () => {
      setIsLoading(true);
      let data = {
        school_id: userData.data.school_id,
      };
      getstudentinfo(data).then((res) => {
        if (res.status === "success") {
          console.log(res);
          setFilteredData(res.data.student_data);
        } else {
          setRows([]);
          toast.error(t("Something went wrong"));
        }
        setIsLoading(false);
      });
    };
    getStudentDetails();
  }, [rowData, userData.data.school_id, t]);

  const navigate = useNavigate();

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setDailyHomework((dailyHomework) => ({
      ...dailyHomework,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const formErrors = {};

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);
      const formData = new FormData();

      // Append each field and its value to the FormData object
      for (const key in dailyHomework) {
        formData.append(key, dailyHomework[key]);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="px-2 px-md-4">
        
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Download Daily Homework")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row">
          <div className="col-md-4 mt-4">
               <label className="form-label">
                 {t("From Date")} {<span style={{ color: "red" }}>*</span>}
               </label>
               <input
                 type="date"
                 name="from_date"
                 className="form-control"
                 onChange={handleChangeInput}
                 // required
               />
             </div>
             <div className="col-md-4 mt-4">
               <label className="form-label">
                 {t("To Date")} {<span style={{ color: "red" }}>*</span>}
               </label>
               <input
                 type="date"
                 name="to_date"
                 className="form-control"
                 onChange={handleChangeInput}
                 // required
               />
             </div>
             <div className="row col-6 mt-4 d-flex justify-content-start" style={{marginLeft:"0.4rem"}}>
             <button type="submit" className="btn btn-primary me-2 col-md-2">
               {t("Search")}
             </button>

             <button
               type="reset"
               className="btn btn-secondary me-2 col-md-2"
             >
               {t("Cancel")}
             </button>
           </div>
          </div>
        </form>
      </div>

      <div className="row col-12 d-flex justify-content-center mt-4 bg-white"></div>
      <div className="px-0 px-md-3">
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Date")}</TableCell>
                  <TableCell align="center">{t("Class")}</TableCell>
                  <TableCell align="center">{t("Section")}</TableCell>
                  <TableCell align="center">{t("File")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{ width: "6rem" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.date || "2024-06-04"}
                        </TableCell>
                        <TableCell align="center" >
                          {row.class || "X"}
                        </TableCell>
                        <TableCell align="center">
                          {row.section ||" A"}
                        </TableCell>
                        <TableCell align="center">
                          {row.file || 3}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>               
              )}
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      ></TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default DownloadDailyHomework;

